export const version = "properties/5.5.0";
//# sourceMappingURL=_version.js.map